import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function StartupVideo() {
  const [loading, setLoading] = useState(true);
  const videoRef = useRef();
  const navigate = useNavigate();

  const videoLink =
    "https://api.thegreenmatter.com/StaticFiles/Videos/The%20Greenmatter.mp4";

  // useEffect(() => {
  //   if (videoRef.current) {
  //     const video = videoRef.current;

  //     const playVideo = async () => {
  //       try {
  //         // Attempt to play immediately
  //         const playPromise = video.play();

  //         if (playPromise !== undefined) {
  //           playPromise
  //             .then(() => {
  //               // Autoplay started!
  //               console.log("Autoplay started successfully.");
  //               setLoading(false); // Only set loading false if play succeeds
  //             })
  //             .catch((error) => {
  //               // Autoplay was prevented. Show a play button or message.
  //               console.error("Autoplay prevented:", error);
  //               setLoading(false); //  set loading false
  //               //  Safari often blocks autoplay unless the video is muted *and*
  //               //  the user has interacted with the page.
  //               //  We can't reliably force play here, but we could show a message:
  //               //  "Click to play the video" and then call video.play() on a user
  //               //  click.  For this startup video, we will just navigate to home.
  //               navigate("/home");
  //             });
  //         }

  //         video.addEventListener("ended", () => {
  //           navigate("/home");
  //         });
  //       } catch (error) {
  //         console.error("Error setting up video:", error);
  //         setLoading(false);
  //         navigate("/home");
  //       }
  //     };

  //     //  Set up event listeners *before* attempting to play
  //     video.addEventListener("canplay", () => {
  //       console.log("Video can play");
  //     });

  //     playVideo();

  //     return () => {
  //       video.removeEventListener("ended", () => {});
  //       video.removeEventListener("canplay", () => {});
  //     };
  //   }
  // }, [navigate]);

  return (
    <div
      className="startup-video-container"
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "black",
      }}
    >
      {loading && <p style={{ color: "white" }}>Loading Video...</p>}
      <video
        ref={videoRef}
        muted // Keep muted for initial autoplay attempt
        playsInline // Important for iOS Safari!
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      >
        <source src={videoLink} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default StartupVideo;

// import React, { useRef, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// function StartupVideo() {
//   const [loading, setLoading] = useState(true);
//   const videoRef = useRef(null);
//   const navigate = useNavigate();

//   const videoLink =
//     "https://api.thegreenmatter.com/StaticFiles/Videos/The%20Greenmatter.mp4";

//   useEffect(() => {
//     if (videoRef.current) {
//       const video = videoRef.current;

//       const playVideo = async () => {
//         try {
//           video.addEventListener("canplay", () => {
//             setLoading(false);
//             video
//               .play()
//               .then(() => {})
//               .catch((error) => {
//                 console.error("Autoplay failed:", error);
//                 setLoading(false);
//                 navigate("/home");
//               });
//           });
//         } catch (error) {
//           console.error("Error playing video:", error);
//           setLoading(false);
//           navigate("/home");
//         }
//       };

//       playVideo();

//       const handleEnded = () => {
//         navigate("/home");
//       };

//       video.addEventListener("ended", handleEnded);

//       return () => {
//         video.removeEventListener("ended", handleEnded);
//         video.removeEventListener("canplay", () => {});
//       };
//     }
//   }, [navigate]);

//   return (
//     <div
//       className="startup-video-container"
//       style={{
//         position: "relative",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         backgroundColor: "black",
//       }}
//     >
//       {loading && <p style={{ color: "white" }}>Loading Video...</p>}
//       <video
//         ref={videoRef}
//         style={{
//           maxWidth: "100%",
//           maxHeight: "100%",
//           objectFit: "contain",
//         }}
//       >
//         <source src={videoLink} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// }

// export default StartupVideo;
